import { makeStyles } from '@material-ui/core';

const useTooltipStyles = makeStyles({

  tooltip__title: {
    whiteSpace: 'pre-line',
    fontSize: '0.75rem',
    fontWeight: 400
  },
  tooltip__icon: {
    marginLeft: '5px',
    marginTop: '-3px'
  },
  tooltip__icon__inline: {
    marginLeft: '5px',
    marginBottom: '-5px'
  },
  tooltip__title_text: {
    color: 'var(--azure)'
  }
});

export default useTooltipStyles;